import React from 'react'
import { Card, Container, Row, Col } from 'react-bootstrap'

const PrivacyPolicy = () => {
    return (
        <>
            <div className='content-inner'>
                <Container fluid className='container'>
                    <Row>
                        <Col lg="12">
                            <Card className="mb-3">
                                <Card.Header>
                                    <h5 className="card-subtitle">Introduction</h5>
                                </Card.Header>
                                <Card.Body>
                                    <p>
                                        At ChatInject, we take your privacy seriously. This Privacy Policy outlines
                                        how we collect, use, and share your personal data when you access or use our
                                        services. By using ChatInject's platform, you acknowledge and accept the
                                        practices and policies described herein, and you consent to the collection,
                                        use, and sharing of your data as outlined in this Privacy Policy.
                                    </p>
                                    <p>
                                        Remember, your use of ChatInject's services is subject to our Terms of Use,
                                        which incorporates this Privacy Policy.
                                    </p>
                                </Card.Body>
                            </Card>
                            <Card className="mb-3">
                                <Card.Header>
                                    <h5 className="card-subtitle">What This Privacy Policy Covers</h5>
                                </Card.Header>
                                <Card.Body>
                                    <p>
                                        This policy details how ChatInject treats personal data collected when you
                                        use our platform. “Personal Data” includes information that identifies or
                                        relates to a particular individual, such as name, email, or IP address, as
                                        defined under applicable laws. This policy does not cover the practices of
                                        companies we do not own or control or people we do not manage.
                                    </p>
                                </Card.Body>
                            </Card>
                            <Card className="mb-3">
                                <Card.Header>
                                    <h5 className="card-subtitle">Personal Data We Collect</h5>
                                </Card.Header>
                                <Card.Body>
                                    <ul>
                                        <li>
                                            <strong>Profile or Contact Data:</strong> Includes your name, email,
                                            phone number, and mailing address.
                                        </li>
                                        <li>
                                            <strong>Payment Data:</strong> Payment card type, last 4 digits of your
                                            card, billing address, and phone number (collected via our payment
                                            processing partner).
                                        </li>
                                        <li>
                                            <strong>Device/IP Data:</strong> Information like your IP address, device
                                            ID, and browser type.
                                        </li>
                                        <li>
                                            <strong>Web Analytics:</strong> Data related to website usage, including
                                            referring sources and page interactions.
                                        </li>
                                        <li>
                                            <strong>Social Network Data:</strong> Data from platforms like Facebook
                                            and Instagram when linked, such as usernames, profile pictures, and time
                                            zones.
                                        </li>
                                    </ul>
                                </Card.Body>
                            </Card>
                            <Card className="mb-3">
                                <Card.Header>
                                    <h5 className="card-subtitle">How We Use Your Data</h5>
                                </Card.Header>
                                <Card.Body>
                                    <ul>
                                        <li>Providing and personalizing services to improve your experience.</li>
                                        <li>
                                            Managing accounts, processing transactions, and providing customer
                                            support.
                                        </li>
                                        <li>
                                            Enhancing platform features and conducting internal analytics.
                                        </li>
                                        <li>Sending communications, including marketing messages.</li>
                                        <li>
                                            Ensuring compliance with legal obligations and platform security.
                                        </li>
                                    </ul>
                                </Card.Body>
                            </Card>
                            <Card className="mb-3">
                                <Card.Header>
                                    <h5 className="card-subtitle">Your Rights</h5>
                                </Card.Header>
                                <Card.Body>
                                    <ul>
                                        <li>Access, correct, or delete your personal information.</li>
                                        <li>
                                            Opt out of marketing communications and data sharing for targeted
                                            advertising.
                                        </li>
                                        <li>
                                            Request details about the categories of personal data collected and
                                            shared.
                                        </li>
                                    </ul>
                                </Card.Body>
                            </Card>
                            <Card className="mb-3">
                                <Card.Header>
                                    <h5 className="card-subtitle">Cookies and Tracking</h5>
                                </Card.Header>
                                <Card.Body>
                                    <p>
                                        ChatInject uses cookies and similar tracking technologies to understand user
                                        behavior, improve services, and personalize content. You can manage your
                                        cookie preferences through your browser settings.
                                    </p>
                                </Card.Body>
                            </Card>
                            <Card className="mb-3">
                                <Card.Header>
                                    <h5 className="card-subtitle">Contact Us</h5>
                                </Card.Header>
                                <Card.Body>
                                    <p>
                                        If you have any questions or comments about this Privacy Policy, the ways in
                                        which we collect and use your Personal Data, or your choices and rights
                                        regarding such collection and use, please do not hesitate to contact us at:
                                    </p>
                                    <p>Email: chatinject@gmail.com</p>
                                    <p>Website: https://chatinject.com/</p>
                                </Card.Body>
                            </Card>


                        </Col>
                    </Row>
                </Container>
            </div>

        </>
    )
}

export default PrivacyPolicy
